import { render, staticRenderFns } from "./file-preview.vue?vue&type=template&id=fd56f8a2&scoped=true"
import script from "./file-preview.vue?vue&type=script&lang=js"
export * from "./file-preview.vue?vue&type=script&lang=js"
import style0 from "./file-preview.vue?vue&type=style&index=0&id=fd56f8a2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd56f8a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Administrator\\.jenkins\\workspace\\tplt.10ndata.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd56f8a2')) {
      api.createRecord('fd56f8a2', component.options)
    } else {
      api.reload('fd56f8a2', component.options)
    }
    module.hot.accept("./file-preview.vue?vue&type=template&id=fd56f8a2&scoped=true", function () {
      api.rerender('fd56f8a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/file-preview/file-preview.vue"
export default component.exports